import React, {FC, useContext} from "react";
import {Accordion} from "react-bootstrap";
import {ChatMessageType, UserChats} from "services";
import {ModerationUser} from "interfaces";
import {EnvSetup} from "enums/Envs";
import {isModerationPackAvailable} from "enums";
import {ModerationChat} from "components/ModerationUserCard/components/ModerationChats/ModerationChat";
import {AuthContext} from "contexts";

interface Props {
    user: ModerationUser;
    chats: UserChats[];
    env?: EnvSetup;
}

export const ModerationDownloadChatsBody: FC<Props> = ({user, chats}) => {
    const {env} = useContext(AuthContext);
    return <div>
        {chats?.map((chat, i) => {
            const messages = chat.messages;
            const matchKey = chat.key;
            const hasAbuse = messages.find(m => m.messageType === ChatMessageType.ScamWarning || m.messageType === ChatMessageType.ScreenshotWarning)
            return <Accordion key={matchKey} className="mb-1">
                <Accordion.Item eventKey={matchKey}>
                    <Accordion.Header>
                        Чат {i + 1} ({messages?.length ?? 0})
                        {hasAbuse &&
                            <span className="badge bg-danger mx-2">Есть нарушения</span>}</Accordion.Header>
                    <Accordion.Body>
                        {isModerationPackAvailable(env) &&
                            <div className="fw-normal mb-3">
                                Пользователь:{' '}
                                <a href={`profile/${matchKey}`} target="_blank"
                                   rel="noreferrer">{chat.name}</a> ({chat.status})
                            </div>}
                        <ModerationChat userGender={user.gender} userKey={user.id} userName={user.name}
                                        messages={messages}/>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        })}
        {chats?.length === 0 && "У пользователя пока нет чатов"}
    </div>
}
